
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.705 1.123l1.144 3.254c.249.63.187 1.344-.165 1.92-.3.437-.735.757-1.234.91v4.8c-.01.54-.23 1.053-.61 1.426s-.89.577-1.415.566H3.768a1.964 1.964 0 01-1.44-.553 2.063 2.063 0 01-.627-1.438v-4.73A2.327 2.327 0 01.454 6.51 2.16 2.16 0 01.15 4.391l1.137-3.26A1.743 1.743 0 012.948 0h8.097a1.736 1.736 0 011.66 1.122zM7.931 12.848h.006v.021a.728.728 0 01-.006-.021zm0 0H6.18a.673.673 0 000-.163v-1.489a.826.826 0 01.28-.578.786.786 0 01.602-.191.799.799 0 01.847.74v1.511c0 .058.008.115.022.17zm2.459 0H8.936a.673.673 0 000-.163v-1.489c-.037-1.04-.887-1.853-1.902-1.821-1.017-.036-1.87.779-1.908 1.821v1.51a.673.673 0 000 .163H3.734a.932.932 0 01-.965-.896V7.264a2.263 2.263 0 001.854-1.779C4.865 6.613 5.875 7.39 7 7.314c1.104.047 2.083-.723 2.322-1.829.194.988.992 1.732 1.97 1.836v4.687a.933.933 0 01-.902.861v-.021zm1.378-6.77a1.13 1.13 0 00.91-.508v.021a.908.908 0 00.048-.811l-1.137-3.212a.556.556 0 00-.544-.318H2.948a.555.555 0 00-.537.29L1.274 4.78a.922.922 0 00.069.931 1.041 1.041 0 00.95.389c.53.03 1.01-.323 1.151-.848a1.25 1.25 0 011.2-1.044c.597 0 1.107.446 1.198 1.052.14.527.626.879 1.158.84a1.113 1.113 0 001.15-.862c.1-.6.605-1.043 1.2-1.051.595-.001 1.104.442 1.199 1.044.14.532.628.887 1.164.847h.055z","fill":"#585858"}})])
          )
        }
      }
    